import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useInterval } from "usehooks-ts";
const defaultDuration = 500;
export const AnimatedNumber = ({ number , duration =defaultDuration  })=>{
    const [latestNumber, setLatestNumber] = useState(number);
    const [previousNumber, setPreviousNumber] = useState(number);
    const [renderNumber, setRenderNumber] = useState(number);
    const step = duration / 1000 * 60;
    useEffect(()=>{
        if (latestNumber !== number) {
            setPreviousNumber(latestNumber);
            setLatestNumber(number);
        }
    }, [
        latestNumber,
        number
    ]);
    useInterval(()=>{
        if (latestNumber !== renderNumber) {
            const diff = (latestNumber - previousNumber) / step;
            const isNegative = diff < 0;
            const newNumber = renderNumber + (isNegative ? Math.floor(diff) : Math.ceil(diff));
            if (isNegative) {
                if (newNumber <= latestNumber) {
                    setRenderNumber(latestNumber);
                } else {
                    setRenderNumber(newNumber);
                }
            } else {
                if (newNumber >= latestNumber) {
                    setRenderNumber(latestNumber);
                } else {
                    setRenderNumber(newNumber);
                }
            }
        }
    }, latestNumber === renderNumber ? null : 1000 / 60);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: renderNumber
    });
};
export default AnimatedNumber;

//# sourceMappingURL=index.js.map